import { Component, Inject, OnInit } from '@angular/core';
import { ModalService } from '@core/services/modal/modal.service';
import {
	MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA,
	MatLegacyDialogRef as MatDialogRef,
	MatLegacyDialog as MatDialog,
} from '@angular/material/legacy-dialog';

@Component({
	selector: 'app-enquiry-error-modal',
	templateUrl: './enquiry-error-modal.component.html',
	styleUrls: ['./enquiry-error-modal.component.scss', './enquiry-error-modal.responsive.scss'],
})
export class EnquiryErrorModalComponent implements OnInit {
	constructor(
		private matDialog: MatDialog,
		private modalService: ModalService,
		private dialogRef: MatDialogRef<EnquiryErrorModalComponent>,

		@Inject(MAT_DIALOG_DATA) public data: { error: Error },
	) {}

	ngOnInit() {
		this.modalService.liftUpModal(this.dialogRef);
	}

	closeAllDialogs() {
		this.matDialog.closeAll();
	}

	closeDialog(result = ''): void {
		this.dialogRef.close(result);
	}
}
